import { FC, useEffect, useState } from 'react'
import { t } from 'i18next'
import Button from '../../../common/components/Button'
import styles from './ChallengeExercise.module.css'
import { OnResponseSubmit, StepResponse } from '../../../types/Exercise'

interface ChallengeExerciseProps {
  id: number
  onResponseSubmit: OnResponseSubmit
  stepResponse?: StepResponse
}

const ChallengeExercise: FC<ChallengeExerciseProps> = ({
  id,
  onResponseSubmit,
  stepResponse,
}) => {
  const [selectedOption, setSelectedOption] = useState<null | boolean>(null)

  const handleButtonClick = (option: boolean) => {
    onResponseSubmit(id, option)
    setSelectedOption(option)
  }

  useEffect(() => {
    setSelectedOption(stepResponse?.response)
  }, [stepResponse?.response])

  return (
    <div className={styles.buttonContainer}>
      <Button
        title={t('exercises.decline')}
        onClick={() => handleButtonClick(false)}
        backgroundColor={'decline'}
        size="third"
        selected={selectedOption === false}
      />
      <Button
        title={t('exercises.accept')}
        onClick={() => handleButtonClick(true)}
        backgroundColor={'accent'}
        size="third"
        selected={selectedOption === true}
      />
    </div>
  )
}

export default ChallengeExercise
